module.exports = __webpack_public_path__ + "img/react-native.cb147c69.png";